<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Settings</h2>
        </b-col>
        <b-col class="float-right">
          <!-- Actions -->
        </b-col>
      </b-row>

      <b-nav>
        <b-nav-item :to="{name: 'settings'}" exact active-class="tab_active">Account</b-nav-item>
        <b-nav-item v-if='profile.team_role.role === "admin"' :to="{name: 'team'}" exact active-class="tab_active">Team</b-nav-item>
        <b-nav-item v-if='profile.team_role.role === "admin"' :to="{name: 'billing'}" exact active-class="tab_active">Billing</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user"/>
  </b-container>
</template>

<script>

import api from '@/lib/api.js'

export default {
  props: ['profile', 'user'],
}
</script>

<style>

</style>
